import {
  gridSizeMdLg12,
  gridSizeMdLg6,
  hasPermission,
  useUploadFile
} from "@/shared";
import {
  GeneralTable
} from "@/shared/components/ui";
import { Button, Grid, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useTableColumnsReporteStock } from "@/erp/inventario/reporte-stock/shared/hook/useTableColumnsReporteStock";
import {
  BODEGAS,
  BodegasParams,
  IUbicacionProductoPaginaRes,
  Ubicaciones,
  UbicacionesParams
} from "@/shared/interfaces/erp/inventario";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import MultiAutocompleteCheckForm from "./MultiAutocompleteCheckForm";
import ScrollDialogSeriesReporteInventario from "./ScrollDialogSeries";
import { IFormSaveResporteStock, TODOSREPORTESTOCK, toCsvSeleccion } from "../hook/useReporteStock";
import { ApiResponse } from "@/shared/interfaces/erp/global/response-axios.interface";
import { MRT_ColumnFilterFnsState, MRT_PaginationState } from "material-react-table";
import ModalStockReporteHistorico from "./ModalStockReporteHistorico";
//import dayjs from "dayjs";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import useAutocompleteFetch, { OPCION_TODOS_BODEGA } from "@/shared/hooks/useAutocompleteFetch";
import { getUbicaciones } from "@/shared/actions/erp";
import { PermissionsEnum } from "@/auth/interfaces";
import { IDataProducto } from "@/shared/interfaces";
import { Refresh } from "@mui/icons-material";
import { IDataSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import ExcelDownloadLoader from "@/erp/inventario/kardex/componente/ExcelDownloadLoader";
import { useExcelDownloadLoaderStore } from "@/erp/inventario/kardex/componente";
import { toast } from "react-toastify";

enum OpcionReporteStockENUM {
  OPCION1 = 'opcion1',
  OPCION2 = 'opcion2'
}


interface SaveResporteStockProps {
  opcion: string
  form: UseFormReturn<IFormSaveResporteStock, any, IFormSaveResporteStock>
  enabled: boolean
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>
  handleFilterTable: (params: IFormSaveResporteStock) => void,
  handleCleanFilterTable: () => void
  dataProductos: ApiResponse<IUbicacionProductoPaginaRes> | undefined
  isLoadingProducto: boolean
  isRefetching: boolean
  pagination: MRT_PaginationState
  setPagination: React.Dispatch<React.SetStateAction<MRT_PaginationState>>
  columnFilters: MRT_ColumnFilterFnsState
  setColumnFilters: React.Dispatch<React.SetStateAction<MRT_ColumnFilterFnsState>>
  watchBodega: boolean
  watchUbicacion: boolean,
  bodegaAll: BODEGAS[]
  isLoadingbodegas: boolean
  handleDownloadFile: () => Promise<void>
  refetchProducto: () => void
}

export default function SaveResporteStock({
  //isLoadingbodegas,
  //bodegaAll,
  opcion,
  form,
  enabled,
  setEnabled,
  handleFilterTable,
  handleCleanFilterTable,
  dataProductos,
  isLoadingProducto,
  isRefetching,
  pagination,
  setPagination,
  columnFilters,
  setColumnFilters,
  watchBodega,
  watchUbicacion,
  //handleDownloadFile,
  refetchProducto
}: SaveResporteStockProps) {

  const initDownload = useExcelDownloadLoaderStore(s => s.initDownload)

  const [openModal, setOpenModal] = useState<boolean>(false);

  const {
    reset,
    control,
  } = form

  const {
    columnsReporteInventariable,
  } = useTableColumnsReporteStock();

  const {
    descargarExcelUrl,
  } = useUploadFile()

  const {
    fetchAutocompleteBodega,
    fetchAutocompleteUbicacion,
    fetchAutocompleteProducto,
    fetchAutocompleteSerie

  } = useAutocompleteFetch();

  // "TODOS" para Bodega: selecciona todas las bodegas (el reporte se genera sin
  // filtro de bodegas). Se agrega AQUI, a nivel de este reporte, para no alterar
  // el resto de paginas que reutilizan fetchAutocompleteBodega.
  const fetchBodegaConTODOS = useCallback(
    (
      search: string,
      page: number,
      isAll: boolean,
      keySearch: keyof BODEGAS = 'nombre',
      params?: BodegasParams,
    ) => {
      return fetchAutocompleteBodega(
        search,
        page,
        isAll,
        keySearch,
        params as BodegasParams,
      ).then((res) => {
        const yaIncluyeTODOS = res.options.some(
          (o) => String(o.codigo) === 'TODOS',
        );
        if (page === 1 && isAll && !yaIncluyeTODOS) {
          return { ...res, options: [OPCION_TODOS_BODEGA, ...res.options] };
        }
        return res;
      });
    },
    [fetchAutocompleteBodega],
  );

  const bodega = form.watch("bodega");
  const ubicacion = form.watch("ubicacion");
  const producto = form.watch("producto");
  const descripcionProducto = form.watch("descripcion_producto");
  const serie = form.watch("serie");

  const hayUbicacion = (ubicacion || []).length > 0;
  const disabledFilters = !hayUbicacion;

  const paramsUbicaciones = useMemo<UbicacionesParams>(
    () => ({
      bodega_in: toCsvSeleccion(bodega) ?? undefined,
      es_transito: false,
      // Activa el scope por perfil en /ubicacion/ (solo el reporte lo envia).
      scope_perfil: '1',
    }),
    [bodega]
  );

  // Al cambiar la seleccion de bodegas, las ubicaciones elegidas dejan de
  // ser validas: se limpian para no filtrar por una combinacion imposible.
  const bodegaSelectionKey = (bodega || []).join(",");
  const ubicacionSelectionKey = (ubicacion || []).join(",");
  const prevBodegaKeyRef = useRef(bodegaSelectionKey);
  const prevUbicacionKeyRef = useRef(ubicacionSelectionKey);

  useEffect(() => {
    const cambioBodega = prevBodegaKeyRef.current !== bodegaSelectionKey;
    const cambioUbicacion = prevUbicacionKeyRef.current !== ubicacionSelectionKey;

    prevBodegaKeyRef.current = bodegaSelectionKey;
    prevUbicacionKeyRef.current = ubicacionSelectionKey;

    if (!cambioBodega && !cambioUbicacion) return;

    // La tabla mostraria datos de la seleccion anterior: se oculta hasta
    // que el usuario vuelva a cargar.
    setEnabled(false);

    if (cambioBodega) {
      reset({ ...form.getValues(), ubicacion: [] });
    }
  }, [bodegaSelectionKey, ubicacionSelectionKey, form, reset, setEnabled]);


  return (
    <>
      <Grid container spacing={2}>


        {/*Aplicar filtros*/}

        <Grid item
          {...gridSizeMdLg6}>

          <Grid
            container
            spacing={3}>

            <MultiAutocompleteCheckForm<BODEGAS>
              control={control}
              size={gridSizeMdLg6}
              name="bodega"
              label="Bodega"
              fetchData={fetchBodegaConTODOS}
              isAll
              getOptionLabel={(opt) => opt.nombre || ''}
              getOptionKey={(o) => o.codigo!}
            />


            <MultiAutocompleteCheckForm<Ubicaciones>
              disabled={watchBodega}
              control={control}
              size={gridSizeMdLg6}
              name="ubicacion"
              label="Ubicación"
              ///* fetch
              isAll
              fetchParams={paramsUbicaciones}
              fetchData={fetchAutocompleteUbicacion}
              loadOptionByValue={async (cod) => {
                const resp = await getUbicaciones({
                  codigo: cod
                })

                return resp.data.data[0] ?? null
              }}
              getOptionLabel={(opt) => opt.nombre || ''}
              getOptionKey={(o) => o.codigo!}
            />

            <CustomAutocompleteFetchForm<IDataProducto>
              required={false}
              size={gridSizeMdLg6}
              control={control}
              name="producto"
              label="Codigo producto"
              getOptionLabel={(opt) => `${opt.codigo}` || ''}
              key={'autocomplete-producto'}
              getOptionKey={(opt) => opt.codigo}
              initialInputValue={form.getValues().producto ?? ''}
              onChangeValue={(e) => {
                setEnabled(false)
                if (!e) {
                  handleFilterTable({
                    ...form.getValues(),
                    url_excel: null,
                    fecha_reporte: null,
                    producto: e as string,
                    estado: false
                  }
                  )
                }

              }}
              ///* fetch
              keySearch="codigo"
              //isAll
              fetchData={fetchAutocompleteProducto}
            />

            <CustomAutocompleteFetchForm<IDataProducto>
              required={false}
              size={gridSizeMdLg6}
              control={control}
              name="descripcion_producto"
              label="Descripción producto"
              getOptionLabel={(opt) => `${opt.descripcion}` || ''}
              key={'autocomplete-producto'}
              getOptionKey={(opt) => opt.descripcion}
              initialInputValue={form.getValues().descripcion_producto ?? ''}
              onChangeValue={(e) => {
                setEnabled(false)
                if (!e) {
                  handleFilterTable({
                    ...form.getValues(),
                    url_excel: null,
                    fecha_reporte: null,
                    descripcion_producto: e as string,
                    estado: false
                  }
                  )
                }
              }}
              ///* fetch
              keySearch="descripcion"
              isAll
              fetchData={fetchAutocompleteProducto}

            />

            <CustomAutocompleteFetchForm<IDataSerie>
              required={false}
              control={control}
              size={gridSizeMdLg6}
              name="serie"
              label="Serie"
              fetchData={fetchAutocompleteSerie}
              isAll={false}
              getOptionLabel={(opt) => opt.serie || ''}
              key={'autocomplete-serie'}
              getOptionKey={(o) => o.serie!}
              keySearch="serie"
              onChangeValue={(e) => {
                setEnabled(false);
                reset({
                  ...form.getValues(),
                  serie: e as string
                })
              }}
            />

          </Grid>

        </Grid>

        <Grid item
          {...gridSizeMdLg6}
        >

          <Grid container spacing={3}>
            {
              opcion == OpcionReporteStockENUM.OPCION1 && (
                <>
                  <Grid item {...gridSizeMdLg6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      disabled={disabledFilters}
                      onClick={() => {
                        handleFilterTable({
                          ...form.getValues(),
                          estado: true
                        });
                      }}
                    >
                      Cargar Stock con Filtros
                    </Button>
                  </Grid>

                  {/* <Grid item {...gridSizeMdLg6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => {
                        reset({
                          estado: true
                        });
                        setEnabled(true);
                      }}
                    >
                      Mostrar Todo
                    </Button>
                  </Grid> */}


                  <Grid item {...gridSizeMdLg6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => {
                        handleCleanFilterTable();
                      }}
                    >
                      Limpiar
                    </Button>
                  </Grid>

                  {
                    hasPermission(PermissionsEnum.reporte_stock_actual_descargar_excel) &&
                    <Grid item {...gridSizeMdLg6}>
                      <Button
                        fullWidth
                        startIcon={<PiMicrosoftExcelLogoFill />}
                        variant="contained"
                        color="success"
                        onClick={() => {
                          //handleDownloadFile()
                          const formValues = form.getValues();
                          try {
                            const params = {
                              bodegas_in: toCsvSeleccion(formValues.bodega) ?? undefined,
                              ubicaciones_in: toCsvSeleccion(formValues.ubicacion) ?? undefined,
                              bodega__es_cliente: false
                            }

                            const ubiTODOS = Array.isArray(formValues.ubicacion) &&
                              formValues.ubicacion.includes(TODOSREPORTESTOCK);

                            const resp = !!params.ubicaciones_in || ubiTODOS;
                            if (!resp) {
                              toast.info('Debe seleccionar al menos una ubicación.');
                              return;
                            }
                            initDownload('ubicacion-producto-simple/excel', params)
                          } catch (error) {
                            console.log(error);
                          }

                        }}
                      >
                        GENERAR EXCEL
                      </Button>
                    </Grid>
                  }

                </>


              )
            }

            {opcion == OpcionReporteStockENUM.OPCION2 && (
              <>
                <Grid item {...gridSizeMdLg12}>
                  <Button
                    disabled={watchUbicacion}
                    fullWidth
                    variant="outlined"
                    onClick={() => {

                      //handleFilterTable();
                      setOpenModal(true);

                    }}
                  >
                    Seleccionar Fecha
                  </Button>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <Button
                    disabled={watchUbicacion}
                    fullWidth
                    variant="outlined"
                    onClick={() => {


                      handleFilterTable({
                        ...form.getValues(),
                        estado: true
                      });

                    }}
                  >
                    Cargar Reporte
                  </Button>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <Button
                    fullWidth
                    disabled={watchUbicacion}
                    variant="outlined"
                    onClick={() => {
                      handleCleanFilterTable();
                    }}
                  >
                    Limpiar
                  </Button>
                </Grid>

              </>
            )}

          </Grid>

        </Grid>

        {
          opcion == OpcionReporteStockENUM.OPCION2 && form.getValues().url_excel && (
            <Grid container item xs={12}
              justifyContent={'space-between'}
              alignContent={'center'}
              alignItems={'center'}
              spacing={2}>

              <Grid item>
                <Typography variant="subtitle2">
                  Reporte historico con fecha: {form.getValues().fecha_reporte}
                </Typography>
              </Grid>

              <Grid item>
                <Button
                  disabled={watchUbicacion}
                  color="success"
                  variant="contained"
                  startIcon={<PiMicrosoftExcelLogoFill />}
                  onClick={() => {
                    descargarExcelUrl(form.getValues().url_excel, `${form.getValues().fecha_reporte}reporte_historico.xlsx`)
                  }}
                >
                  DESCARGAR EXCEL
                </Button>
              </Grid>
            </Grid>
          )
        }

        {
          <Grid item xs={12} textAlign={'end'}>
            <Button
              onClick={
                refetchProducto
              }
              startIcon={<Refresh />}
              variant="contained">
              Actualizar
            </Button>
          </Grid>
        }



        <Grid item xs={12}>

          <GeneralTable
            columns={columnsReporteInventariable}
            data={enabled
              ? dataProductos?.data.data ?? []
              : []}
            isLoading={isLoadingProducto}
            isRefetching={isRefetching}
            rowCount={dataProductos?.data?.count ?? 0}
            pagination={pagination}
            onPaging={setPagination}
            enableGlobalFilter={false}
            //
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //
            canEdit={false}
            enableEditing={false}
          />

        </Grid>
      </Grid>

      <ScrollDialogSeriesReporteInventario />

      <ModalStockReporteHistorico
        openModal={openModal}
        setOpenModal={setOpenModal}
        params={{
          bodega: form.getValues().bodega,
          ubicacion: form.getValues().ubicacion
        }
        }
        handleDataReporteHistoriso={(value) => {
          setOpenModal(false)
          handleFilterTable({
            ...form.getValues(),
            fecha_reporte: value.fecha_reporte,
            url_excel: value.url_excel,
            estado: true,
          })
        }}
      />

      <ExcelDownloadLoader />
    </>
  )
}